(function () {
  class BigWin extends PIXI.Container {
    constructor(numStages, thresholds, timePerStage) {
      super();

      this._numStages = numStages;
      this._thresholds = thresholds;

      this._timePerStage = timePerStage;

      this._nextState = "IDLE";
      this._introTimer = undefined;
      this._currentStage = 0;
      this._localStage = 0;
      this._countTimer = undefined;
      this._outroTimer = undefined;
      this._winAmount = 0;
      this._animating = false;
      this._skippedBeforeTriggered = false;
      this._newSpin = false;

      this._awardGrowAnim = undefined;
      this._bigWinPanelTweenProgress = 0;

      this._allowOrientationChange = false;

      this._particleEmitEndTime = 1500;
      this._endTimerDelayTime = 2000;
      this._endTimerTime = 750;

      this._isBigWin = false;

      this._useAlternateStartPos = false;

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      messageBus.subscribe(
        "stake:stakeChanged",
        this.onStakeChanged.bind(this)
      );
      messageBus.subscribe("spinner:SpinEvent", this.onSpin.bind(this));

      const self = this;
      StateMachine.Create(this);
      Reflex.addToUpdate(function (delta) {
        self.update(delta);
      });

      this.stateMachine.addState("IDLE", function () {});

      this.stateMachine.addState("INTRO", function () {
        if (self.phase.enter()) {
          self._awardValue.visible = true;
          self._awardValue.alpha = 1;
          self._bigWinAwardValueParent.scale.x = 5;
          self._bigWinAwardValueParent.scale.y = 5;
          self.glowEffect.visible = true;
        }

        if (self.phase.timed(750)) {
          const progress = self.phase.Progress;
          let newScale = 0.2 * Math.abs(Math.sin(Math.PI * progress));
          self._bigWinAwardValueParent.scale.x = 1 + 4 * (1 - progress);
          self._bigWinAwardValueParent.scale.y = 1 + 4 * (1 - progress);
        }

        if (self.phase.once()) {
          if (gameController.inFreeSpins) {
            gameController.winningsContainer.visible = false;
          } else {
            gameController.winningsContainer.visible = true;
          }

          self._bigWinAwardValueParent.scale.x = 1;
          self._bigWinAwardValueParent.scale.y = 1;
          self._awardValue.alpha = 1;

          self.stateMachine.switchState(self._nextState);
        }

        if (self.phase.exit()) {
          self._bigWinAwardValueParent.scale.x = 1;
          self._bigWinAwardValueParent.scale.y = 1;
          self._awardValue.alpha = 1;
        }
      });

      this.stateMachine.addState("ANIMATE_SMALLWIN", function () {
        if (self.phase.enter()) {
          self._awardValue.visible = true;
          self._awardValue.alpha = 1;
          self._bigWinAwardValueParent.scale.x = 0;
          self._bigWinAwardValueParent.scale.y = 0;
          self._awardValueTextContainer.scale = { x: 1, y: 1 };
          self.glowEffect.visible = true;
          soundManager.play("coinRain");
          self.smallWinParticles.particleEmitter.emit = true;
          self.smallWinParticles.visible = true;

          self.smallWinMovementAnim = gsap
            .timeline()
            .to(self._bigWinAwardValueParent, {
              duration: 0.6,
              ease: "power.inOut",
              alpha: 1,
              onComplete: () => {
                self.smallWinParticles.particleEmitter.emit = false;
              },
            });

          self.smallWinAnim = gsap
            .timeline()
            .to(self._bigWinAwardValueParent.scale, {
              duration: 0.3,
              ease: "power.inOut",
              y: 1.4,
              x: 1.4,
              onComplete: () => {
                self.smallWinParticles.particleEmitter.emit = true;
                self.smallWinParticles.visible = true;
              },
            })
            .to(self._bigWinAwardValueParent.scale, {
              duration: 0.1,
              ease: "linear",
              y: 1,
              x: 1,
            })
            .to(self._bigWinAwardValueParent.position, {
              duration: 0.6,
              ease: "linear",
              y: self._awardValueStartPosFeatures.position.getY() - 20,
              onStart: () => {},
              onComplete: () => {
                self.glowEffect.visible = false;
              },
            })
            .to(self._bigWinAwardValueParent.position, {
              duration: 0.6,
              ease: "linear",
              y: self._awardValueStartPosFeatures.position.getY(),
              onStart: () => {},
              onComplete: () => {},
            })
            .to(self._bigWinAwardValueParent.position, {
              duration: 0.2,
              ease: "linear",
              y: 1000,
              onStart: () => {
                gsap.to(self._awardValue, {
                  duration: 0.2,
                  ease: "power.inOut",
                  alpha: 0,
                  onComplete: () => {},
                });
              },
              onComplete: () => {
                self.smallWinParticles.particleEmitter.emit = false;
                self.smallWinParticles.visible = false;
                self.smallWinAnimComplete = true;
              },
            });
        }

        gameController.winningsContainer.visible = true;

        if (self.phase.hold()) {
          if (self.smallWinAnimComplete) {
            self.phase.step();
          }
        }

        if (self.phase.once()) {
          self._bigWinAwardValueParent.scale.x = 1;
          self._bigWinAwardValueParent.scale.y = 1;

          self.stateMachine.switchState(self._nextState);
        }

        if (self.phase.exit()) {
          self._bigWinAwardValueParent.scale.x = 1;
          self._bigWinAwardValueParent.scale.y = 1;
        }
      });

      this.stateMachine.addState("ANIMATE_SMALLESTWIN", function () {
        if (self.phase.enter()) {
          self._awardValue.visible = true;
          self._awardValue.alpha = 1;
          self._bigWinAwardValueParent.scale.x = 0;
          self._bigWinAwardValueParent.scale.y = 0;
          self.glowEffect.visible = false;
          self.smallWinParticles.particleEmitter.emit = false;
          self.smallWinParticles.visible = false;
          self._awardValueTextContainer.scale = { x: 1, y: 1 };

          self.smallWinMovementAnim = gsap
            .timeline()
            .to(self._bigWinAwardValueParent, {
              duration: 0.6,
              ease: "power.inOut",
              alpha: 1,
              onComplete: () => {},
            });

          self.smallWinAnim = gsap
            .timeline()
            .to(self._bigWinAwardValueParent.scale, {
              duration: 0.3,
              ease: "power.inOut",
              y: 1.4,
              x: 1.4,
              onComplete: () => {
                self.smallWinParticles.particleEmitter.emit = false;
                self.smallWinParticles.visible = false;
              },
            })
            .to(self._bigWinAwardValueParent.scale, {
              duration: 0.1,
              ease: "linear",
              y: 1,
              x: 1,
            })
            .to(self._bigWinAwardValueParent.position, {
              duration: 0.6,
              ease: "linear",
              y: self._awardValueStartPosFeatures.position.getY() - 20,
              onStart: () => {},
              onComplete: () => {
                self.glowEffect.visible = false;
              },
            })
            .to(self._bigWinAwardValueParent.position, {
              duration: 0.6,
              ease: "linear",
              y: self._awardValueStartPosFeatures.position.getY(),
              onStart: () => {},
              onComplete: () => {},
            })
            .to(self._bigWinAwardValueParent.position, {
              duration: 0.2,
              ease: "linear",
              y: 1000,
              onStart: () => {
                gsap.to(self._awardValue, {
                  duration: 0.2,
                  ease: "power.inOut",
                  alpha: 0,
                  onComplete: () => {},
                });
              },
              onComplete: () => {
                self.smallWinParticles.particleEmitter.emit = false;
                self.smallWinParticles.visible = false;
                self.smallWinAnimComplete = true;
              },
            });
        }

        if (self.phase.hold()) {
          if (self.smallWinAnimComplete) {
            self.phase.step();
          }
        }

        if (self.phase.once()) {
          self._bigWinAwardValueParent.scale.x = 1;
          self._bigWinAwardValueParent.scale.y = 1;
          //self._awardValue.alpha = 1;

          self.stateMachine.switchState(self._nextState);
        }

        if (self.phase.exit()) {
          self._bigWinAwardValueParent.scale.x = 1;
          self._bigWinAwardValueParent.scale.y = 1;
          //self._awardValue.alpha = 1;
        }
      });

      this.stateMachine.addState("ANIMATE_BIG_WIN_START", function () {
        if (self.phase.enter()) {
          this.Skipped = false;
          self.prepBgAnim();
        }

        if (self.phase.timed(1250)) {
        }

        if (self.phase.once()) {
          self.stateMachine.switchState("IDLE");
        }

        if (self.phase.exit()) {
          timerManager.stop(self._introTimer);
        }
      });

      this.stateMachine.addState("ANIMATE_BIG_WIN_PANEL", function () {
        if (self.phase.once()) {
          self._bigWinContainer.visible = true;
          self._mainPanel.visible = true;
          self._mainPanel.alpha = 1;
          self._localStage = self._currentStage;
          ++self._currentStage;
          self._stageContainers.forEach(function (container) {
            container.visible = false;
          });
          self._stageContainers[self._localStage].visible = true;
          self._stageContainers[self._localStage].alpha = 1;
          self._stageContainers[self._localStage].scale.x = 1;
          self._stageContainers[self._localStage].scale.y = 1;
          self._stageContainers[self._localStage].ray.visible = true;
          self._mainPanel.visible = true;

          console.log("Local Stage: " + self._localStage);

          if (self._localStage === 0) {
            self._stageContainers[self._localStage].visible = false;

            const startX = self._awardValueStartPos.position.getX();
            const startY = self._awardValueStartPos.position.getY();
            self._bigWinAwardValueParent.position.x = startX;
            self._bigWinAwardValueParent.position.y = startY;

            self._stageContainers[self._localStage].ray.visible = true;
            self._stageContainers[self._localStage].ray.alpha = 1;

            self._mainPanel.scale.x = 0;
            self._mainPanel.scale.y = 0;

            self._bigWinPanelTweenProgress = 0;
            self.bigWinPanelTween = gsap
              .timeline()
              .to(self, {
                _bigWinPanelTweenProgress: 100,
                duration: 0.3,
                ease: "power.inOut",
                onUpdate: () => {
                  const currentOrientationStartY =
                    self._awardValueStartPos.position.getY();
                  const currentOrientationEndY =
                    self._awardValueEndPos.position.getY();
                  const currentYDiff =
                    currentOrientationEndY - currentOrientationStartY;
                  self._bigWinAwardValueParent.y =
                    currentOrientationStartY +
                    currentYDiff * (self._bigWinPanelTweenProgress / 100);
                },
              })
              .to(self._mainPanel.scale, {
                duration: 0.3,
                ease: "power.inOut",
                y: 1,
                x: 1,
                onComplete: () => {
                  if (!self.Skipped) {
                    self._stageContainers[self._localStage].visible = true;
                  }
                },
              })
              .to(self.glowEffect.scale, {
                duration: 0.8,
                ease: "linear",
                y: 0,
                onComplete: () => {
                  self.glowEffect.visible = false;
                  self.glowEffect.scale.y = 1;
                },
              });
          } else {
            const winPanelPos = self._mainPanel.position;
            this.bumpBigWinPanel = gsap
              .timeline()
              .to(self._mainPanel.position, {
                duration: 0.1,
                ease: "power.inOut",
                y: winPanelPos.y - 60,
                onComplete: () => {},
              })
              .to(self._mainPanel.position, {
                duration: 0.1,
                ease: "power.inOut",
                y: winPanelPos.y,
                onComplete: () => {},
              });

            const defaultPos = self._awardValue.position;

            this.bumpBigWinValue = gsap
              .timeline()
              .to(self._awardValue.position, {
                duration: 0.1,
                ease: "power.inOut",
                y: defaultPos.y - 60,
                onComplete: () => {},
              })
              .to(self._awardValue.position, {
                duration: 0.1,
                ease: "power.inOut",
                y: defaultPos.y,
                onComplete: () => {},
              });
          }

          self._particles.particleEmitter.emit = true;
          self._particles.visible = true;
        }

        if (self.phase.timed(750)) {
          // self._stageContainers[self._localStage].alpha = self.phase.Progress;
          // self._stageContainers[self._localStage].scale.x =
          //   1 + 4 * (1 - self.phase.Progress);
          // self._stageContainers[self._localStage].scale.y =
          //   1 + 4 * (1 - self.phase.Progress);
        }

        if (self.phase.exit()) {
          self._stageContainers[self._localStage].alpha = 1;
          self._stageContainers[self._localStage].scale.x = 1;
          self._stageContainers[self._localStage].scale.y = 1;
          self._stageContainers[self._localStage].ray.visible = false;
          self._stageContainers[self._localStage].visible = false;
        }
      });

      this.stateMachine.addState("ANIMATE_BIG_WIN_RESET_PANEL", function () {
        if (self.phase.once()) {
          self.stateMachine.switchState("ANIMATE_BIG_WIN_PANEL");
        }
      });

      this.stateMachine.addState("BACK_TO_MAIN_GAME", function () {
        if (self.phase.enter()) {
          self._animating = false;
          self.backToMainGame();
        }
      });

      this.stateMachine.addState("BACK_TO_MAIN_GAME_FROM_SKIP", function () {
        if (self.phase.enter()) {
          self._animating = false;
        }
      });

      this.stateMachine.addState(
        "BACK_TO_MAIN_GAME_FROM_SMALL_WIN",
        function () {
          if (self.phase.enter()) {
          }
          if (self.phase.once()) {
            self._animating = false;
            self._awardValue.visible = false;
            self.glowEffect.visible = false;
            self.backToMainGameFromSmallerWin(false);
          }
        }
      );
    }

    isCurrentlyPlaying() {
      return this._isBigWin;
    }

    update(delta) {
      if (this.stateMachine) {
        this.stateMachine.update();
      }
      if (this._animating) {
        const rotThisSpin = delta / 1000;
        this._rays.rotation =
          (this._rays.rotation + rotThisSpin) % (Math.PI * 2);
      }
    }

    onGameConfigEvent() {
      this._rays = resourceManager.get("bigWinRayContainer");
      this.bigWinRay = resourceManager.get("bigWinRayContainer:bigWinRay");
      this.hugeWinRay = resourceManager.get("bigWinRayContainer:hugeWinRay");
      this.epicWinRay = resourceManager.get("bigWinRayContainer:epicWinRay");
      this.massiveWinRay = resourceManager.get(
        "bigWinRayContainer:massiveWinRay"
      );
      this.monsterWinRay = resourceManager.get(
        "bigWinRayContainer:monsterWinRay"
      );

      this._rays.visible = false;

      this._stageContainers = [];
      for (let i = 0; i < this._numStages; ++i) {
        this._stageContainers[i] = resourceManager.get(
          "bigWin:stage" + i + "Container"
        );
        this._stageContainers[i].visible = false;
        switch (i) {
          case 0:
            this._stageContainers[i].ray = this.bigWinRay;
            break;
          case 1:
            this._stageContainers[i].ray = this.hugeWinRay;
            break;
          case 2:
            this._stageContainers[i].ray = this.epicWinRay;
            break;
          case 3:
            this._stageContainers[i].ray = this.massiveWinRay;
            break;
          case 4:
            this._stageContainers[i].ray = this.monsterWinRay;
            break;
        }
        this._stageContainers[i].ray.visible = false;
      }

      this._mainPanel = resourceManager.get("bigWin:moneyPanel");
      this._mainPanel.visible = false;

      this.characters = resourceManager.get("bigWin:moneyPanel:characters");
      this.characters.visible = false;

      this.congratulations = resourceManager.get(
        "bigWin:moneyPanel:Congratulations"
      );
      this.congratulations.visible = false;

      this.youhavewon = resourceManager.get("bigWin:moneyPanel:you have won");
      this.youhavewon.visible = false;

      this.bigWinCont = resourceManager.get("bigWin");

      this.glowEffect = resourceManager.get("bigWinAwardValueContainer:glow");
      this.glowEffect.visible = false;

      this._bigWinContainer = resourceManager.getContainer("bigWinContainer");
      this._bigWinContainer.visible = false;

      this._awardValueContainer = resourceManager.getContainer(
        "awardValueContainer"
      );
      this._awardValueContainer.visible = false;
      this._bigWinAwardValueParent = resourceManager.get(
        "bigWinAwardValueContainer"
      );
      this._awardValueTextContainer = resourceManager.get(
        "bigWinAwardValueContainer:valueContainer"
      );
      this._awardValue = resourceManager.get(
        "bigWinAwardValueContainer:valueContainer:bigWinAwardValue"
      );

      this._awardValueStartPos = resourceManager.get(
        "bigWinAwardValueStartPos"
      );
      this._awardValueStartPosFeatures = resourceManager.get(
        "bigWinAwardValueStartPosFeatures"
      );
      this._awardValueEndPos = resourceManager.get("bigWinAwardValueEndPos");

      this._screenDim = resourceManager.get("screenDim");
      this._screenDim.beginFill(0x000000);
      this._screenDim.lineStyle(0, 0x000000);
      this._screenDim.drawRect(0, 0, 1280, 1280);
      this._screenDim.visible = false;
      this._screenDim.alpha = 0;

      this._particles = particleManager.createEmitter(
        "bigwin_emitter",
        "bigWinParticlesContainer",
        0,
        0,
        false
      );
      this._particles.visible = false;
      this._particles.particleEmitter.emit = false;

      this.smallWinParticles = particleManager.createEmitter(
        "smallwin_emitter",
        "bigWinAwardValueContainer:smallWinParticlesContainer",
        0,
        0,
        false
      );
      this.smallWinParticles.visible = false;
      this.smallWinParticles.particleEmitter.emit = false;

      this._cappedWinPopup = resourceManager.get(
        "featurePopupContainer:cappedWinPopup"
      );
      this._cappedWinPopup.visible = false;
      this._cappedWinPopupButton = resourceManager.get(
        "featurePopupContainer:cappedWinPopup:pressStartColourBox"
      );
      this._cappedWinPopupButton.interactive = false;
      this._popupMaskDimObject = resourceManager.get("popupMaskDimObject");

      this._skipBigWinBox = resourceManager.get("bigWin:skipBigWinBox");
      this._skipBigWinBox.interactive = false;
      this._skipBigWinBox.visible = false;
      this._skipBigWinBox.mousedown = this._skipBigWinBox.touchstart =
        this.skip.bind(this);
    }

    onStakeChanged(stake) {
      this._stake = resourceManager
        .getController("stakeController")
        .getBaseStake();
    }

    checkBigWin(winAmount) {
      return winAmount >= this._thresholds[0] * this._stake;
    }

    start(
      winAmount,
      callback,
      bigWinOrNothing,
      smallWinOnly,
      screenObscuredCallback,
      useAlternateStartPos,
      capped,
      smallestWinOnly
    ) {
      this._screenDim.visible = true;
      this._screenDim.alpha = 0;

      gsap.to(this._screenDim, {
        duration: 1,
        alpha: 0.6,
      });

      if (capped) {
        this._cappedWinPopup.visible = true;
        this._cappedWinPopup.alpha = 0;
        const self = this;
        timerManager.addTimer(
          500,
          function (progress) {
            self._popupMaskDimObject.show(true, progress);
            self._cappedWinPopup.alpha = progress;
          },
          function () {
            self._popupMaskDimObject.show(true, 1);
            self._cappedWinPopup.alpha = 1;

            self._cappedWinPopupButton.interactive = true;
            self._cappedWinPopupButton.touchend =
              self._cappedWinPopupButton.mouseup = function () {
                self._cappedWinPopup.visible = false;
                self._popupMaskDimObject.show(false);
                self._cappedWinPopupButton.interactive = false;
                self._cappedWinPopupButton.touchend =
                  self._cappedWinPopupButton.mouseup = function () {};
                self.startBigWin(
                  winAmount,
                  callback,
                  bigWinOrNothing,
                  smallWinOnly,
                  screenObscuredCallback,
                  useAlternateStartPos,
                  smallestWinOnly
                );
              };
          }
        );
      } else {
        this.startBigWin(
          winAmount,
          callback,
          bigWinOrNothing,
          smallWinOnly,
          screenObscuredCallback,
          useAlternateStartPos,
          smallestWinOnly
        );
      }
    }

    startBigWin(
      winAmount,
      callback,
      bigWinOrNothing,
      smallWinOnly,
      screenObscuredCallback,
      useAlternateStartPos,
      smallestWinOnly
    ) {
      //bit of a hack to stop big win thinking it needs to show a win on initNewSpin
      if (this._newSpin) {
        return;
      }

      if (useAlternateStartPos === undefined) {
        useAlternateStartPos = false;
      }

      this._useAlternateStartPos = useAlternateStartPos;

      if (bigWinOrNothing === undefined) {
        bigWinOrNothing = false;
      }
      if (smallWinOnly === undefined) {
        smallWinOnly = false;
      }
      this._isBigWin = false;

      // this._bigWinRayAnim.play();
      // this._hugeWinRayAnim.play();
      // this._epicWinRayAnim.play();
      // this._massiveWinRayAnim.play();
      // this._monsterWinRayAnim.play();

      //this._bigWinRayAnim.alpha = 0;
      //this._bigWinRayAnim.visible = true;
      this._rays.visible = true;

      // gsap.to(this._bigWinRayAnim, {
      //   duration: 0.5,
      //   alpha: 1,
      // });

      this._screenObscuredCallbackInvoked = false;
      this._animating = true;
      this._callback = callback;
      this._screenObscuredCallback = screenObscuredCallback;
      this._winAmount = winAmount;
      this._awardValue.visible = true;
      this._awardValueContainer.visible = true;

      this._allowOrientationChange = true;

      this.smallWinAnimComplete = false;

      if (this._skippedBeforeTriggered) {
        this._particleEmitEndTime = 0;
        this._endTimerDelayTime = 100;
        this._endTimerTime = 250;
        this._skippedBeforeTriggered = false;
        this.doSmallestWin(true);
      } else {
        this._skippedBeforeTriggered = false;
        if (
          winAmount >= this._thresholds[0] * this._stake &&
          !smallWinOnly &&
          !smallestWinOnly
        ) {
          this._particleEmitEndTime = 1500;
          this._endTimerDelayTime = 3000;
          this._endTimerTime = 750;

          this.doBigWin();
        } else if (winAmount > this._stake && !smallestWinOnly) {
          if (!bigWinOrNothing) {
            this._particleEmitEndTime = 250;
            this._endTimerDelayTime = 750;
            this._endTimerTime = 750;
            this.doSmallWin();
          } else {
            this._animating = false;
            this._allowOrientationChange = false;
            callback();
          }
        } else if (winAmount <= this._stake || smallestWinOnly) {
          if (!bigWinOrNothing) {
            this._particleEmitEndTime = 250;
            this._endTimerDelayTime = 750;
            this._endTimerTime = 750;
            this.doSmallestWin();
          } else {
            this._animating = false;
            this._allowOrientationChange = false;
            callback();
          }
        }
      }
    }

    doSmallestWin() {
      if (this._useAlternateStartPos) {
        this._bigWinAwardValueParent.position.set(
          this._awardValueStartPosFeatures.position.getX(),
          this._awardValueStartPosFeatures.position.getY()
        );
      } else {
        this._bigWinAwardValueParent.position.set(
          this._awardValueStartPosFeatures.position.getX(),
          this._awardValueStartPosFeatures.position.getY()
        );
      }
      this._awardValue.setText(
        this.formatText(this._winAmount).replace("X", "")
      );
      this._awardValue.visible = true;
      gameController.winningsContainer.visible = true;
      this._nextState = "BACK_TO_MAIN_GAME_FROM_SMALL_WIN";
      this.stateMachine.switchState("ANIMATE_SMALLESTWIN");
      const self = this;
      timerManager.addTimeout(500, function () {
        this._allowOrientationChange = false;
        //self._callback();
      });
    }

    doSmallWin() {
      this._bigWinAwardValueParent.position.set(
        this._awardValueStartPosFeatures.position.getX(),
        this._awardValueStartPosFeatures.position.getY()
      );

      this._awardValue.setText(
        this.formatText(this._winAmount).replace("X", "")
      );
      this._nextState = "BACK_TO_MAIN_GAME_FROM_SMALL_WIN";
      this.stateMachine.switchState("ANIMATE_SMALLWIN");

      const self = this;
      timerManager.addTimeout(500, function () {
        this._allowOrientationChange = false;
        //self._callback();
      });
    }

    hideText() {
      this._awardValue.visible = false;
    }

    formatText(amount) {
      return gdk.formatCurrency(amount);
    }

    doBigWin() {
      resourceManager.getContainer("bigWinBgContainerLandscape").visible = true;
      this._isBigWin = true;

      gameData.musicManager.fadeOutAllMusic(0.3);
      gameData.musicManager.startBigWin();

      this._nextState = "ANIMATE_BIG_WIN_START";
      this.stateMachine.switchState("INTRO");

      this._currentStage = 0;
      this.initialCountup();

      if (this._useAlternateStartPos) {
        this._bigWinAwardValueParent.position.set(
          this._awardValueStartPosFeatures.position.getX(),
          this._awardValueStartPosFeatures.position.getY()
        );
      } else {
        this._bigWinAwardValueParent.position.set(
          this._awardValueStartPos.position.getX(),
          this._awardValueStartPos.position.getY()
        );
      }
    }

    initialCountup() {
      const self = this;

      //game.thunderAnim.play(0);

      gameData.musicManager.startCountUp();

      const initialValue = this._thresholds[0] * this._stake * 1;

      this._countTimer = timerManager.addTimer(
        2100,
        function (progress) {
          const curVal = initialValue * progress;
          self._awardValue.setText(self.formatText(curVal).replace("X", ""));
        },
        function () {
          self._awardValue.setText(
            self.formatText(initialValue).replace("X", "")
          );

          let nextThreshold = self.calculateNextThreshold(self._winAmount);

          let amountToCount = self.calculateAmountToCount(
            initialValue,
            nextThreshold,
            self._winAmount
          );

          self.countupTotal(initialValue, amountToCount);
        }
      );
    }

    countupTotal(initialValue, amountToCount) {
      if (this.Skipped) {
        this.showEndScreen();
        this.backToMainGame();
        this.stateMachine.switchState("BACK_TO_MAIN_GAME_FROM_SKIP");
      } else {
        this.stateMachine.switchState("ANIMATE_BIG_WIN_PANEL");
        const self = this;

        this._skipBigWinBox.interactive = true;
        this._skipBigWinBox.visible = true;

        let range = 0;
        if (this._currentStage === this._thresholds.length - 1) {
          range = this._stake * 1000;
        } else {
          range =
            (this._thresholds[this._currentStage + 1] -
              this._thresholds[this._currentStage]) *
            this._stake;
        }
        const pct = amountToCount / range;
        const time = this._timePerStage * pct;

        this._awardGrowAnim = gsap.to(self._awardValueTextContainer, {
          duration: 1,
          pixi: { scaleX: 1.5, scaleY: 1.5 },
        });

        this._countTimer = timerManager.addTimer(
          time,
          function (progress) {
            const curVal = initialValue + amountToCount * progress;
            self._awardValue.setText(self.formatText(curVal).replace("X", ""));
          },
          function () {
            const newValue = initialValue + amountToCount;
            self._awardValue.setText(
              self.formatText(newValue).replace("X", "")
            );

            if (newValue < self._winAmount) {
              let nextThreshold = self.calculateNextThreshold(self._winAmount);
              let amountToCount = self.calculateAmountToCount(
                newValue,
                nextThreshold,
                self._winAmount
              );
              self.countupTotal(newValue, amountToCount);
            } else {
              self.outro();
            }
          }
        );
      }
    }

    calculateNextThreshold(fullAmount) {
      //game.thunderAnim.play(0);

      if (this._currentStage === this._thresholds.length - 1) {
        return fullAmount;
      } else {
        return this._thresholds[this._currentStage + 1] * this._stake;
      }
    }

    calculateAmountToCount(initialValue, newThreshold, fullAmount) {
      if (fullAmount <= newThreshold) {
        return fullAmount - initialValue;
      } else {
        return newThreshold - initialValue;
      }
    }

    prepBgAnim() {
      for (let stage = 0; stage < this._thresholds.length; stage++) {
        this._stageContainers[stage].visible = false;
        this._stageContainers[stage].ray.visible = false;
      }
      this._awardValue.visible = true;
      this._bigWinAwardValueParent.visible = true;
      this._bigWinContainer.alpha = 1;
      this._bigWinContainer.visible = true;
      this._mainPanel.scale.x = 0;
      this._mainPanel.scale.y = 0;
      this._awardValueTextContainer.visible = true;
      this._awardValue.alpha = 1;
      this._awardValue.scale = { x: 1, y: 1 };

      const self = this;
      this._introTimer = timerManager.addDelayedTimer(
        500,
        500,
        function (progress) {
          //self._bigWinContainer.alpha = progress;
        },
        function () {
          //self._mainPanel.visible = true;

          self._bigWinContainer.alpha = 1;
          if (self._screenObscuredCallback) {
            self._screenObscuredCallbackInvoked = true;
            self._screenObscuredCallback();
          }
        }
      );
    }

    outro() {
      const self = this;

      gameData.musicManager.endCountUp();

      this._outroTimer = timerManager.addTimeout(2750, function () {
        self.showEndScreen();
        self.backToMainGame();
      });
    }

    showEndScreen() {
      if (
        !this._screenObscuredCallbackInvoked &&
        this._screenObscuredCallback !== undefined
      ) {
        this._screenObscuredCallback();
      }

      this._mainPanel.visible = true;
      this._mainPanel.scale = { x: 1, y: 1 };
      this._mainPanel.alpha = 1;
      this._awardValue.setText(
        this.formatText(this._winAmount).replace("X", "")
      );

      gsap.to(this.glowEffect.scale, {
        duration: 0.4,
        ease: "linear",
        y: 0,
        onComplete: () => {
          this.glowEffect.visible = false;
          this.glowEffect.scale.y = 1;
        },
      });

      const endY = this._awardValueEndPos.position.getY();
      this._bigWinAwardValueParent.position.setY(endY);

      this.characters.visible = true;

      const characterEndPos = this.characters.position;

      this.characters.position.y = -600;
      gsap
        .timeline()
        .to(this.characters.position, {
          duration: 0.4,
          y: -206,
          ease: "linear",
          onComplete: () => {
            this.congratulations.visible = true;
            this.youhavewon.visible = true;
          },
        })
        .to(this._mainPanel.position, {
          duration: 0.2,
          y: 565,
          ease: "linear",
          onStart: () => {
            this.bigWinAwardValueParentTweenProgress = 0;
            gsap
              .timeline()
              .to(this, {
                bigWinAwardValueParentTweenProgress: 100,
                duration: 0.2,
                ease: "linear",
                onUpdate: () => {
                  const currentOrientationEndY =
                    this._awardValueEndPos.position.getY();
                  this._bigWinAwardValueParent.y =
                    currentOrientationEndY +
                    66 * (this.bigWinAwardValueParentTweenProgress / 100);
                },
                onComplete: () => {
                  this.bigWinAwardValueParentTweenProgress = 0;
                },
              })
              .to(this, {
                bigWinAwardValueParentTweenProgress: 100,
                duration: 0.2,
                ease: "linear",
                onUpdate: () => {
                  const currentOrientationEndY =
                    this._awardValueEndPos.position.getY();
                  this._bigWinAwardValueParent.y =
                    currentOrientationEndY +
                    66 -
                    66 * (this.bigWinAwardValueParentTweenProgress / 100);
                },
                onComplete: () => {
                  this.bigWinAwardValueParentTweenProgress = 0;
                },
              });
          },
        })
        .to(this._mainPanel.position, {
          duration: 0.2,
          y: 498,
          ease: "power.in",
          onComplete: () => {},
        });

      timerManager.stop(this._outroTimer);

      // turn off all stages - determine which stage we are in then reactivate it
      let activeStage = 0;
      for (let stage = 0; stage < this._thresholds.length; stage++) {
        this._stageContainers[stage].visible = false;
        this._stageContainers[stage].ray.visible = false;

        const val = this._stake * this._thresholds[stage];
        if (this._winAmount >= val) {
          activeStage = stage;
        }
      }

      this._stageContainers[activeStage].visible = false;
      this._stageContainers[activeStage].ray.visible = false;

      this._stageContainers[activeStage].scale.x = 1;
      this._stageContainers[activeStage].scale.y = 1;
      this._mainPanel.visible = true;

      this._animating = false;

      this._awardValue.setText(
        this.formatText(this._winAmount).replace("X", "")
      );
      this._bigWinContainer.alpha = 1;
      this._bigWinContainer.visible = true;
      this._isBigWin = false;
      gameData.musicManager.endCountUp();
    }

    backToMainGameFromSmallerWin() {
      this.stateMachine.switchState("IDLE");

      timerManager.addTimeout(250, () => {
        this._callback();
      });
    }

    backToMainGame() {
      const self = this;
      for (let stage = 0; stage < this._thresholds.length; stage++) {
        this._stageContainers[stage].visible = false;
        this._stageContainers[stage].ray.visible = false;
      }

      this._skipBigWinBox.visible = false;
      this._skipBigWinBox.interactive = false;
      this._rays.visible = false;

      this._awardGrowAnim = undefined;

      gsap.to(this._screenDim, {
        duration: 1,
        delay: this._endTimerDelayTime,
        alpha: 0,
        onComplete: () => {
          this._screenDim.visible = false;
          this._screenDim.alpha = 0;
        },
      });

      timerManager.addTimer(
        this._particleEmitEndTime,
        function (progress) {},
        function () {
          self._particles.particleEmitter.emit = false;
        }
      );

      gameData.musicManager.endBigWin();

      timerManager.addDelayedTimer(
        this._endTimerDelayTime,
        this._endTimerTime,
        function (progress) {
          self._bigWinContainer.alpha = 1 - progress;
          self._awardValue.alpha = 1 - progress;
          self.bigWinRay.alpha = 1 - progress;
        },
        function () {
          self._stageContainers.forEach(function (container) {
            container.alpha = 1;
            container.visible = false;
          });
          self._bigWinContainer.alpha = 1;
          self._bigWinContainer.visible = false;
          self._awardValue.alpha = 1;
          self._awardValue.visible = false;
          self.glowEffect.visible = false;
          self.bigWinRay.visible = false;
          self.congratulations.visible = false;
          self.youhavewon.visible = false;
          self.characters.visible = false;

          gameData.musicManager.setIdleMusic();

          resourceManager.getContainer(
            "bigWinBgContainerLandscape"
          ).visible = false;

          self.stateMachine.switchState("IDLE");
          this._allowOrientationChange = false;
          self._callback();
          self._callback = undefined;
        }
      );
    }

    skip() {
      if (this._animating) {
        if (this._isBigWin) {
          if (this._awardGrowAnim) {
            this._awardGrowAnim.progress(100);
          }
          if (this.bigWinPanelTween) {
            this.bigWinPanelTween.progress(100);
          }
          // //Threshold Anim
          if (this.bumpBigWinPanel) {
            this.bumpBigWinPanel.kill();
          }
          if (this.bumpBigWinValue) {
            this.bumpBigWinValue.kill();
          }

          if (!this.Skipped) {
            this._bigWinContainer.visible = true;
            this._awardValue.visible = true;
          }
          this.Skipped = true;
          if (this._countTimer) {
            this._countTimer.remainingTime = 0;
            timerManager.stop(this._countTimer);
            this._countTimer = undefined;
            timerManager.stop(this._outroTimer);
            this._outroTimer = undefined;
            this.showEndScreen();

            let activeStage = 0;
            for (let stage = 0; stage < this._thresholds.length; stage++) {
              this._stageContainers[stage].visible = false;
              this._stageContainers[stage].ray.visible = false;

              const val = this._stake * this._thresholds[stage];
              if (this._winAmount >= val) {
                activeStage = stage;
              }
            }

            this._stageContainers[0].visible = false;
            this._stageContainers[0].ray.visible = false;
            this._bigWinContainer.visible = true;
            this._mainPanel.visible = true;
            this._mainPanel.alpha = 1;
            //this.stateMachine.switchState("BACK_TO_MAIN_GAME_FROM_SKIP");
            this.stateMachine.switchState("BACK_TO_MAIN_GAME");
            gameData.musicManager.endCountUp();
          }
          // this.showEndScreen();
          // this.backToMainGame();
        } else {
          if (this.smallWinMovementAnim) {
            //this.smallWinMovementAnim.kill();
            this.smallWinMovementAnim.timeScale(1.5);
          }
          if (this.smallWinAnim) {
            //this.smallWinAnim.kill();
            this.smallWinAnim.timeScale(1.5);
          }
          // this.smallWinParticles.particleEmitter.emit = false;
          // this.smallWinParticles.visible = false;
          // this.glowEffect.visible = false;
          // this._bigWinContainer.visible = false;
          // this._awardValue.visible = false;

          // this._nextState = undefined;

          // this.backToMainGameFromSmallerWin();
        }
      }
    }

    onSpin() {
      this._skippedBeforeTriggered = false;
    }

    clearSkippedFlag() {
      this._skippedBeforeTriggered = false;
    }
  }

  var bigWinCreator = function (json) {
    return new BigWin(json.numStages, json.thresholds, json.timePerStage);
  };

  var bigWinInitialiser = function (json, bigWin) {};

  var bigWinFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "bigWin",
    bigWinCreator,
    bigWinInitialiser,
    bigWinFilesRequired
  );
})();
